import React, { Suspense } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import Navigation from "./Navigation/Navigation";
import Footer from "./Components/Footer/Footer";
import "./App.css";
import BlogContextProvider from "./context/BlogContext";
import SocialContextProvider from "./context/SocialContext";
import Fallback from "./Ui/Fallback";
const Home = React.lazy(() => import("./Components/Home/Home"));
const Menu = React.lazy(() => import("./Components/Menu/Menu"));
const Blog = React.lazy(() => import("./Components/Blog/Blog"));
const About = React.lazy(() => import("./Components/About/About"));
const SingleBlog = React.lazy(() => import("./Components/Blog/SingleBlog"));

function App() {
  return (
    <div className="App">
      <Router>
        <Navigation />
        <Suspense fallback={<Fallback />}>
          <Switch>
            <Route path="/" exact>
              <BlogContextProvider>
                <Home />
              </BlogContextProvider>
            </Route>
            <Route path="/menu" exact>
              <Menu />
            </Route>
            <Route path="/blog" exact>
              <BlogContextProvider>
                <Blog />
              </BlogContextProvider>
            </Route>
            <Route path="/single-blog/:id" exact>
              <BlogContextProvider>
                <SingleBlog />
              </BlogContextProvider>
            </Route>
            <Route path="/about" exact>
              <About />
            </Route>
            <Redirect to="/" />
          </Switch>
        </Suspense>
        <SocialContextProvider>
          <Footer />
        </SocialContextProvider>
      </Router>
    </div>
  );
}

export default App;
